<template>
  <b-card-code
    title=""
    no-body
  >
    <b-link :to="{ path: '/project-device-key/add' }">
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        class="sidebar-right ml-1"
        variant="outline-primary"
      >
        <feather-icon icon="PlusIcon" /> Create
      </b-button>
    </b-link>
    <div><div class="h-50 d-inline-block" /></div>
    <div class="d-flex justify-content-between flex-wrap">
      <!-- sorting  -->
      <b-form-group
        label="Sort"
        label-size="sm"
        label-align-sm="left"
        label-cols-sm="3"
        label-for="sortBySelect"
        class="ml-1"
      >
        <b-input-group size="sm">
          <b-form-select
            id="sortBySelect"
            v-model="sortBy"
            :options="sortOptions"
          >
            <template #first>
              <option value="">
                none
              </option>
            </template>
          </b-form-select>
          <b-form-select
            v-model="sortDesc"
            size="sm"
            :disabled="!sortBy"
          >
            <option :value="false">
              Asc
            </option>
            <option :value="true">
              Desc
            </option>
          </b-form-select>
        </b-input-group>
      </b-form-group>
      <!-- filter -->
      <b-form-group
        label="Filter"
        label-cols-sm="3"
        label-align-sm="left"
        label-size="sm"
        label-for="filterInput"
        class="ml-1"
      >
        <b-input-group size="sm">
          <b-form-input
            id="filterInput"
            v-model="filter"
            type="search"
            placeholder="Type to Search"
          />
          <b-input-group-append>
            <b-button
              :disabled="!filter"
              @click="filter = ''"
            >
              Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
    <b-table
      :key="key"
      striped
      hover
      responsive
      class="position-relative"
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
:sort-direction="sortDirection" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered"
    >
      <template #cell(created_at)="data">
        {{ dateFormat(data.value) }}
      </template>
      <template #cell(logo)="data">
        <b-img
          width="50"
          :src="data.value"
        />
      </template>
      <template #cell(status)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>
      <template #cell(action)="row">
        <span>
          <b-dropdown
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template v-slot:button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="text-body align-middle mr-25"
              />
            </template>
            <b-dropdown-item>
              <b-link :to="{ path: '/project-device-key/detail/'+ row.item.id}">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Edit</span>
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link
                v-b-modal.modal-center
                @click="rowOnDelete(row.item.id)"
              >
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Delete</span>
              </b-link>
            </b-dropdown-item>
          </b-dropdown>
        </span>
      </template>
    </b-table>
    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <p class="text-nowrap align-left">
        &nbsp;Total Rows {{ totalRows }}
      </p>
      <b-form-group
        label="Per Page"
        label-cols="6"
        label-align="left"
        label-size="sm"
        label-for="sortBySelect"
        class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          size="sm"
          inline
          :options="pageOptions"
          @change="filterData"
        />
      </b-form-group>
      <p class="text-nowrap mb-md-0 mr-1 align-left" />
      <!-- pagination -->
      <div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
          @input="filterData"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
  </b-card-code>
</template>
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BTable, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store/index'

export default {
  components: {
    BCardCode, BTable, BImg, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem, ToastificationContent,
  },
  data() {
    return {
      dir: false,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      key: 0,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      status: [
        {
          AC: 'Active', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
        },
        {
          AC: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
        },
      ],
    }
  },
  computed: {
    ...mapState({
      totalRows: state => state.device.key.totalRows,
      fields: state => state.device.key.fields,
      items: state => state.device.key.items,
      perPage: state => state.device.key.perPage,
      pageOptions: state => state.device.key.pageOptions,
    }),
    sortOptions() {
      return this.fields.filter(f => f.sortable).map(f => ({ text: f.label, value: f.key }))
    },
    dateFormat() {
      return create_at => this.$options.filters.formatDate(create_at)
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        this.dir = true
        return this.dir
      }
      this.dir = false
      return this.dir
    },
    mapFilter() {
      return { page: this.currentPage, limit: this.perPage }
    },
  },
  created() {
    this.filterData()
  },
  methods: {
    filterData() {
      this.$store.dispatch('device/getAllKey', this.mapFilter)
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      this.currentPage = 1
      this.$store.state.device.key.totalRows = filteredItems.length
    },
    advanceSearch(val) {
      this.searchTerm = val
    },
    rowOnDelete(id) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete everything.', {
          title: 'Please Confirm', size: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'No', cancelVariant: 'outline-secondary', hideHeaderClose: false, centered: true,
        })
        .then(value => {
          if (value === true) {
            this.$store.dispatch('device/removeKey', id)
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch('device/getAllKey', this.mapFilter)
                  this.notification('Success', 'CheckIcon', 'success', 'You have successfully')
                } else {
                  this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
                }
              },
              error => {
                this.notification('Failed', 'CloseIcon', 'danger', 'You have unsuccessful')
              })
          }
        })
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
  },
  directives: {
    Ripple,
  },
}
</script>
